import './common'

import './layout/header'

import './home/show'

import './setting/show'
import './setting/shops/index'
import './setting/users/index'
import './setting/brands/index'
